import power from "./modules/power";

const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.login.language,
  size: state => state.app.size,
  device: state => state.app.device,
  mybtns: state => state.power.mybtns,
  user: state => state.login.user
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js